'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var providerIntents = exports.providerIntents = {
  configuration: 'configuration',
  shop: 'shop',
  pricing: 'pricing',
  manage: 'manage',
  checkout: 'checkout',
  thankyou: 'thankyou',
  banner: 'banner'
};

var storePubSub = exports.storePubSub = {
  refreshCart: 'REFRESH_CART',
  checkoutState: 'CHECKOUT_STATE',
  checkout: 'STORE_CHECKOUT'
};